import { render, staticRenderFns } from "./ListModel.vue?vue&type=template&id=f80f5bd4"
import script from "./ListModel.vue?vue&type=script&lang=js"
export * from "./ListModel.vue?vue&type=script&lang=js"
import style0 from "./ListModel.vue?vue&type=style&index=0&id=f80f5bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports